module.exports = {"513301100":"炉城镇","513301101":"姑咱镇","513301102":"新都桥镇","513301103":"塔公镇","513301104":"沙德镇","513301105":"金汤镇","513301201":"雅拉乡","513301202":"时济乡","513301203":"前溪乡","513301204":"舍联乡","513301205":"麦崩乡","513301206":"三合乡","513301208":"捧塔乡","513301210":"贡嘎山乡","513301211":"普沙绒乡","513301212":"吉居乡","513301213":"瓦泽乡","513301214":"呷巴乡","513301215":"甲根坝乡","513301216":"朋布西乡","513301218":"孔玉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513301.json
// module id = 2226
// module chunks = 0